/**
 * `ОПР.1` (`АРХ-Н37`): станция с выключенным опросом не показывается на
 * карточках объекта, в общем списке станций и в счёте `InfoBoard`.
 *
 * Правило одно на все три места: адрес счётчика не 0 **и** опрос не выключен.
 * Окно модуля это правило не использует: там строка остаётся серой, и по ней
 * опрос включают обратно.
 */
export function isStationVisibleOnCards(station: any): boolean {
  const address =
    station?.["Meters.meter_address"] ?? station?.meter_address;

  return Number(address) !== 0 && station?.polling_enabled !== false;
}
